import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import useMobile from "../../hooks/useMobile";
import useTab from "../../hooks/useTab";
import MissionVision from "../aboutus/MissionVision";
import { Fade } from "react-awesome-reveal";
import {
  ICraftsmanshipSlider,
  IHighlightsTitle,
  IMissionVision,
} from "../../exports/interfaces";

const Info = (props: {
  missionVisionData: IMissionVision[];
  craftsmanshipSlider: ICraftsmanshipSlider[];
  highlightsTitle: IHighlightsTitle[];
}) => {
  const mobile = useMobile();
  const tab = useTab();
  const images = props.craftsmanshipSlider?.map((data) => {
    return {
      image: data?.image[0]?.media?.name,
    };
  });

  return (
    <>
      <div>
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-48c84d06 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="48c84d06"
          data-element_type="section"
          data-settings='{"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div
            className="elementor-container elementor-column-gap-default"
            style={{ maxWidth: "unset" }}
          >
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-753ac9ef"
                data-id="753ac9ef"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap custom-elementor-title">
                    <Fade
                      cascade
                      damping={0.2}
                      direction="up"
                      triggerOnce={true}
                    >
                      <div
                        className="elementor-element elementor-element-764d6a6 elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="764d6a6"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp","hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h2 className="elementor-heading-title elementor-size-default">
                            {props?.highlightsTitle[0]?.title}
                          </h2>
                        </div>
                      </div>
                      <div
                        className="elementor-element elementor-element-168f4c49 elementor-invisible elementor-widget elementor-widget-heading"
                        data-id="168f4c49"
                        data-element_type="widget"
                        data-settings='{"_animation":"fadeInUp","_animation_delay":400,"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                        data-widget_type="heading.default"
                      >
                        <div className="elementor-widget-container">
                          <h5 className="elementor-heading-title elementor-size-default" dangerouslySetInnerHTML={{__html: props?.highlightsTitle[0]?.sub_title}}/>
                        </div>
                      </div>
                    </Fade>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Fade direction="up" triggerOnce={true}>
          <MissionVision missionVisionData={props.missionVisionData} />
        </Fade>

        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-69e827d elementor-section-stretched elementor-section-full_width elementor-section-height-default elementor-section-height-default elementor-invisible"
          data-id="69e827d"
          data-element_type="section"
          data-settings='{"stretch_section":"section-stretched","animation":"fadeInUp","animation_delay":600,"hoteller_ext_is_background_parallax":"false","hoteller_ext_is_background_on_scroll":"false"}'
        >
          <div className="elementor-container elementor-column-gap-default">
            <div className="elementor-row">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-4008f9e"
                data-id="4008f9e"
                data-element_type="column"
                data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
              >
                <div className="elementor-column-wrap elementor-element-populated">
                  <div className="elementor-widget-wrap">
                    <div
                      className="elementor-element elementor-element-8d93419 elementor-widget elementor-widget-hoteller-gallery-horizontal"
                      data-id="8d93419"
                      data-element_type="widget"
                      data-settings='{"hoteller_ext_is_scrollme":"false","hoteller_ext_is_smoove":"false","hoteller_ext_is_parallax_mouse":"false","hoteller_ext_is_infinite":"false","hoteller_ext_is_fadeout_animation":"false"}'
                      data-widget_type="hoteller-gallery-horizontal.default"
                    >
                      <div className="elementor-widget-container">
                        <div
                          className="tg_horizontal_gallery_wrapper"
                          data-autoplay="0"
                          data-loop="0"
                          data-navigation="1"
                          data-pagination="0"
                          data-parallax="0"
                          data-fullscreen="0"
                        >
                          <Fade direction="up" triggerOnce={true}>
                            <div
                              className="tg_horizontal_gallery_cell custom-info-slideshow__slide-image"
                              style={{ height: "80dvh" }}
                            >
                              <Swiper
                                modules={[Navigation]}
                                slidesPerView={mobile || tab ? 2 : 3}
                                navigation
                                spaceBetween={10}
                                grabCursor={true}
                                style={{
                                  height: "100%",
                                }}
                              >
                                {images?.map((image, index) => {
                                  return (
                                    <SwiperSlide key={index}>
                                      <div
                                        className="slideshow__slide-image background-absolute custom-info-slideshow__slide-image"
                                        style={{
                                          height: "80dvh",
                                          backgroundImage: `url(${process.env.REACT_APP_cmsUrl}/uploads/${image?.image})`,
                                          backgroundRepeat: "no-repeat",
                                          backgroundSize: "cover",
                                          backgroundPosition: "center",
                                        }}
                                      >
                                        <div className="custom-gradient"></div>
                                      </div>
                                    </SwiperSlide>
                                  );
                                })}
                              </Swiper>
                            </div>
                          </Fade>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <style>
          {`
                    .swiper-button-next,
                    .swiper-button-prev {
                        height: 26px;
                    }
                    .swiper-button-next::after,
                    .swiper-button-prev::after {
                        color: white;
                        font-size: 24px;
                    }
                    .swiper-pagination-bullet {
                        background-color: #ffffff;
                    }
                    .swiper-pagination {
                        bottom: 11px !important;
                    }
                    @media (max-width: 810px) {
                        .swiper-pagination {
                            bottom: 17px !important;
                        }
                    }
                `}
        </style>
      </div>
    </>
  );
};

export default Info;
